import { PersistentFormControl, PersistentFormGroup } from '@utility/persistent-forms';

export class SiteServicesPaymentOptionsFormGroup extends PersistentFormGroup<{
    prePaidDebitCardControl: PersistentFormControl<boolean | null>;
    checkControl: PersistentFormControl<boolean | null>;
    wireTransferControl: PersistentFormControl<boolean | null>;
    collectBankDetailsControl: PersistentFormControl<boolean | null>;
    reimburseControl: PersistentFormControl<boolean | null>;
    payQuickerControl: PersistentFormControl<boolean | null>;
}> {
    constructor() {
        super(
            {
                prePaidDebitCardControl: new PersistentFormControl<boolean | null>(null),
                checkControl: new PersistentFormControl<boolean | null>(null),
                wireTransferControl: new PersistentFormControl<boolean | null>(null),
                collectBankDetailsControl: new PersistentFormControl<boolean | null>(null),
                reimburseControl: new PersistentFormControl<boolean | null>(null),
                payQuickerControl: new PersistentFormControl<boolean | null>(null),
            },
            [
                (control) => {
                    const formGroup = control as SiteServicesPaymentOptionsFormGroup;
                    const value = formGroup.value;
                    if (!value) return null;

                    if (
                        !value.prePaidDebitCardControl &&
                        !value.checkControl &&
                        !value.wireTransferControl &&
                        !value.reimburseControl &&
                        !value.payQuickerControl
                    )
                        return { required: 'Option is required' };
                    return null;
                },
            ]
        );
    }
}
